import { without } from 'lodash';

import {
    CHANGE_ITEM_CRYPTA_AUDIO_GENRES,
    CLOSE_CRYPTA_AUDIO_GENRES_EDITOR,
    CryptaAudioGenresEditorAction,
    OPEN_CRYPTA_AUDIO_GENRES_EDITOR
} from '../../actions/targetings/cryptaAudioGenres';
import { CryptaAudioGenresEditorState } from '../../typings/audienceTargetings';
import { CryptaAudioGenresEditorsState, State } from '../../typings/state';

export const defaultCryptaAudioGenresEditorsState: CryptaAudioGenresEditorState = {
    isOpen: false,
    checkedItems: []
};

export const cryptaAudioGenresEditorsInitialState: CryptaAudioGenresEditorsState = {};

export function cryptaAudioGenresEditor(
    state: CryptaAudioGenresEditorsState = cryptaAudioGenresEditorsInitialState,
    action: CryptaAudioGenresEditorAction,
    fullState: State
): CryptaAudioGenresEditorsState {
    switch (action.type) {
        case OPEN_CRYPTA_AUDIO_GENRES_EDITOR: {
            const editor = state[action.id] || {
                ...defaultCryptaAudioGenresEditorsState
            };

            if (action.itemsId.length !== 0) {
                editor.checkedItems = action.itemsId;
            }

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case CHANGE_ITEM_CRYPTA_AUDIO_GENRES: {
            const editor = state[action.id];
            const checkedItems = editor.checkedItems;
            const itemId = action.itemId;

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: checkedItems.includes(itemId)
                        ? without(checkedItems, itemId)
                        : checkedItems.concat(itemId)
                }
            };
        }

        case CLOSE_CRYPTA_AUDIO_GENRES_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    checkedItems: action.itemsId || editor.checkedItems,
                    isOpen: false
                }
            };
        }

        default:
            return state;
    }
}
